import react, { useState } from 'react'
import { getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut } from 'firebase/auth'
import { auth, db } from '../Firebase';
import { doc, setDoc } from 'firebase/firestore/lite';
import { Link, Navigate, useNavigate } from 'react-router-dom'
import { useAuthContext } from './UseAuth';


export const useSignup = () => {
    const navigate = useNavigate();


    const [error, setError] = useState(null)
    const [error2, setError2] = useState(null)
    const educattainment = ''
    const languagespoken = ''
    const fluency = ''
    const { dispatch } = useAuthContext()



    const signup = ({ email, password, firstname, lastname }) => {
        setError2(null)
        const { user } = createUserWithEmailAndPassword(auth, email, password)

            .then((response) => {

                const user = response.user

                setDoc(doc(db, 'users', user.uid), {



                    firstname: firstname,
                    lastname: lastname,
                    email: user.email,
                    uid: user.uid,
                    educattainment,
                    languagespoken,
                    fluency

                })
                dispatch({ payload: user })
                document.getElementById('accountModal2').click();
                alert("User Successfully Registered")

            })
            .catch((error) => {
                
                console.log(error.message)
                setError(error.message)
            })
    }
    const login = ({ email, password }) => {
        setError(null)

        signInWithEmailAndPassword(auth, email, password)
            .then((response) => {
                const user = response.user
                console.log(user.uid)
                dispatch({ type: 'LOGIN', payload: user })
                alert("User Successfully Login")
                navigate("/contributions");
            }
            )
            .catch((error2) => {
                console.log(error2.message)
                setError2(error2.message)
            })
    }


    const logout = () => {
        signOut(auth)
            .this((response) => {
                console.log('Successfuly Logout')
                dispatch({ type: 'LOGOUT' })
            })
            .catch((err) => {
                console.log(err.message)
            })
    }




    return { signup, error, login, error2, logout }
}
